import React from 'react'
import {Card, Container, Row, Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const PolitiqueCookies = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <Container>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <br/>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Politique de cookies")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Le site www.seeks.biz utilise des cookies afin de garantir son bon fonctionnement, d'améliorer l'expérience utilisateur et de mesurer l'audience.")}</p>
                                    
                                    <h5>{t("Types de cookies utilisés :")}</h5>
                                    <ul>
                                        <li>{t("Cookies techniques : indispensables à la navigation.")}</li>
                                        <li>{t("Cookies de mesure d'audience : anonymes, utilisés pour l'analyse du trafic (ex : Google Analytics).")}</li>
                                        <li>{t("Cookies de personnalisation : utilisés pour mémoriser vos préférences.")}</li>
                                    </ul>
                                    
                                    <h5>{t("Gestion des cookies :")}</h5>
                                    <p>{t("À tout moment, vous pouvez gérer vos préférences via le bandeau de consentement ou les paramètres de votre navigateur.")}</p>
                                    <p>{t("Pour en savoir plus, contactez : contact@seeks.biz")}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default PolitiqueCookies
